import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('driedCookingProcessCheck', 'driedCookingProcessChecks');

const customActions = {
  async LOAD_driedCookingProcessChecks({ commit, rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('driedCookingProcessChecks')
      .query({
        $filter: 'IsDeleted eq false AND status ne null',
        $expand: 'StockItem',
      });
    commit('SET_driedCookingProcessChecks', data);
    return data;
  },
  async LOAD_driedCookingProcessChecksByStockItemId({ commit, rootGetters }, stockItemId) {
    const data = await odata.o(rootGetters)
      .get('driedCookingProcessChecks')
      .query({
        $filter: `IsDeleted eq false AND StockItemId eq ${stockItemId}`,
        $expand: 'StockItem',
      });
    commit('SET_driedCookingProcessChecks', data);
    return data;
  },
};

export default { ...actions, ...customActions };
